import { DefaultBodyType, rest, PathParams } from 'msw';
import { PostRequestResponse } from '../../api';

export const iterableUnhandledGet = rest.get(
  'https://api.iterable.com/api/*',
  (req, res, context) => {
    if (window.__TESTS__) {
      return undefined;
    }

    return res(context.status(200), context.json({}));
  },
);

const DEFAULT_POST_BODY: PostRequestResponse = {
  msg: 'Unhandled POST request managed',
  code: 'Success',
};

type iterableResponse = PostRequestResponse & PathParams;

export const iterableUnhandledPost = rest.post<DefaultBodyType, iterableResponse>(
  'https://api.iterable.com/api/*',
  (req, res, context) => {
    return res(context.status(200), context.json(DEFAULT_POST_BODY));
  },
);
